// Lightweight helpers for building spin math (symbol weights and grid generation).

export const buildWeights = (allSymbols, specials) =>
  allSymbols.reduce((acc, s) => {
    if (specials.low[s]) acc[s] = specials.low[s];
    else acc[s] = specials.default;
    return acc;
  }, {});

export const createPickSymbol = (weights, fallback) => () => {
  const total = Object.values(weights).reduce((a, b) => a + b, 0);
  let rnum = Math.random() * total;
  for (const key of Object.keys(weights)) {
    rnum -= weights[key];
    if (rnum <= 0) return key;
  }
  return fallback;
};

export const createGridGenerator = ({ reels, rows, pickSymbol, wrapperId = 'wrapper_stacks' }) => (stickyMask) =>
  Array.from({ length: reels }).map((_, col) =>
    Array.from({ length: rows }).map((_, row) => {
      if (stickyMask?.has(`${col}-${row}`)) return wrapperId;
      return pickSymbol();
    })
  );
